module.exports = __webpack_public_path__ + "static/media/faq.a5961180.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/faq.pdf
// module id = 481
// module chunks = 2